import { MapGroupId } from "../../types";
import imgPath from "../../mapImages/CustomsDorms.webp";

const mapData = {
  groupId: MapGroupId.Customs,
  groupName: {
    en: "Customs",
    ru: "Таможня",
  },
  title: {
    en: "Dorms",
    ru: "Общага",
  },
  imgPath,
  extracts: [],
};

export default mapData;
